import { IVehiclePageProps } from '../../interfaces';
import { useClientLazyQuery } from '../useClientLazyQuery';
import { NEXT_ENTITY, QUERY_VARIANT } from '@common/interfaces/entity';
import { API_CACHE_POLICY } from 'types';
import { setIsOrderRefetching, setOrder } from '@store/slices/orderSlice';
import { useAppDispatch } from '@store/hooks';
import { useCallback } from 'react';

export const useClientRefetchOrder = (props: IVehiclePageProps) => {
  const { refetchOrder } = useClientOrderQuery(props);
  return refetchOrder;
};

const useClientOrderQuery = (props: IVehiclePageProps) => {
  const dispatch = useAppDispatch();

  const [fetchOrder] = useClientLazyQuery(NEXT_ENTITY.ORDER, {
    variables: { id: props.orderId },
    queryVariant: QUERY_VARIANT.CONCISED,
    nextOptions: { cache: API_CACHE_POLICY.NO_STORE },
    onCompleted: (data) => {
      dispatch(setOrder(data));
      dispatch(setIsOrderRefetching(false));
    },
    onError: (error) => {
      dispatch(setIsOrderRefetching(false));
    },
  });

  const refetchOrder = useCallback(async () => {
    dispatch(setIsOrderRefetching(true));
    await fetchOrder();
  }, []);

  return { refetchOrder: refetchOrder };
};
